import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-phone-input-2/lib/bootstrap.css";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MainContainer from "../../layout/MainContainer";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showError, showToast } from "../../constants/toasts";
import {
  useAddUserMutation,
  useLazyMemberDetailsQuery,
  useUpdateUserMutation,
} from "../../service/user";
import {
  useLazyGetDietaryQuery,
  useLazyGetExpertiseQuery,
  useLazyGetInterestQuery,
} from "../../service/cms";
import PhoneInput from "react-phone-input-2";
import dayjs, { Dayjs } from "dayjs";
import { Members } from "../../types/General";
import Loader from "../../constants/Loader";

interface Interests {
  created: string;
  id: number;
  isActive: boolean;
  name: string;
}

enum MembershipType {
  SOLO = "Solo",
  DUO = "Duo",
}

enum UserMembershipType {
  SINGLE = "Single",
  DUO = "Duo",
}

enum MembershipStatus {
  FREE = "Free",
  PAID = "Paid",
}

enum Alignment {
  ACTIVATE = "activate",
  INVITE = "archived",
}

function AddUser() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { type } = location.state || {};

  const [addUser] = useAddUserMutation();
  const [updateUser] = useUpdateUserMutation();
  const [getInterest] = useLazyGetInterestQuery();
  const [getExpertise] = useLazyGetExpertiseQuery();
  const [getDietary] = useLazyGetDietaryQuery();
  const [userDetails] = useLazyMemberDetailsQuery();

  const [selectedValue, setSelectedValue] = useState("Single");
  const [selectedValue1, setSelectedValue1] = useState("Trial");
  const [selectedPayer, setSelectedPayer] = useState("Primary");
  const [dob, setDob] = useState<Dayjs | null>(null);
  const [secondaryDob, setSecondaryDob] = useState<Dayjs | null>(null);
  const [userData, setUserData] = useState<Members>();
  const [submitted, setSubmitted] = useState(false);
  const [selectedInterests, setSelectedInterests] = useState<string[]>([]);
  const [selectedPartnerInterests, setSelectedPartnerInterests] = useState<
    string[]
  >([]);
  const [interests, setInterests] = useState<Interests[]>([]);
  const [expertise, setExpertise] = useState([]);
  const [dietary, setDietary] = useState([]);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedExpertise, setSelectedExpertise] = useState<string[]>([]);
  const [selectedPartnerExpertise, setSelectedPartnerExpertise] = useState<
    string[]
  >([]);
  const [selectedDietary, setSelectedDietary] = useState<string[]>([]);
  const [selectedPartnerDietary, setSelectedPartnerDietary] = useState<
    string[]
  >([]);
  const [alignment, setAlignment] = useState("activate");

  const handleInterestChange = (interest: string) => {
    setSelectedInterests(
      (prev) =>
        prev.includes(interest)
          ? prev.filter((item) => item !== interest) // remove if already selected
          : [...prev, interest] // add if not selected
    );
  };

  const handlePartnerInterestChange = (interest: string) => {
    setSelectedPartnerInterests(
      (prev) =>
        prev.includes(interest)
          ? prev.filter((item) => item !== interest) // remove if already selected
          : [...prev, interest] // add if not selected
    );
  };

  const handleChangeNewRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue1(event.target.value);
  };

  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };

  const handleChangePayer = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedPayer(value);
  };

  const handleChangeGender = (event: SelectChangeEvent) => {
    const { value } = event.target;
    formik.setFieldValue("gender", value);
  };

  const handleChangeSecondaryGender = (event: SelectChangeEvent) => {
    const { value } = event.target;
    formik.setFieldValue("secondaryGender", value);
  };

  const handleChangeExpertise = (expertise: string) => {
    setSelectedExpertise((prev) =>
      prev.includes(expertise)
        ? prev.filter((item) => item !== expertise)
        : [...prev, expertise]
    );
  };

  const handleChangePartnerExpertise = (expertise: string) => {
    setSelectedPartnerExpertise((prev) =>
      prev.includes(expertise)
        ? prev.filter((item) => item !== expertise)
        : [...prev, expertise]
    );
  };

  const handleChangeDietary = (expertise: string) => {
    setSelectedDietary((prev) =>
      prev.includes(expertise)
        ? prev.filter((item) => item !== expertise)
        : [...prev, expertise]
    );
  };

  const handleChangePartnerDietary = (expertise: string) => {
    setSelectedPartnerDietary((prev) =>
      prev.includes(expertise)
        ? prev.filter((item) => item !== expertise)
        : [...prev, expertise]
    );
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
    setAlignment("activate");
  };

  const handleChangeToggle = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phoneNumber", phone?.replace(country.dialCode, ""));
    formik.setFieldValue("countryDialCode", country?.dialCode);
  };

  const handleChangeSecondaryPhone = (phone: any, country: any) => {
    formik.setFieldValue(
      "secondaryPhoneNumber",
      phone?.replace(country.dialCode, "")
    );
    formik.setFieldValue("secondaryDialCode", country?.dialCode);
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: userData?.name || "",
      email: userData?.email || "",
      phoneNumber: userData?.phoneNumber?.phone || "",
      countryDialCode: userData?.phoneNumber?.countryDialCode || "+971",
      gender: userData?.gender || "",
      address: userData?.address || "",
      referalCode: userData?.referedCode || "",
      partnerEmail: userData?.partner?.email || "",
      isInvited: true,
      secondaryName: userData?.partner?.name || "",
      secondaryEmail: userData?.partner?.email || "",
      secondaryPhoneNumber: userData?.partner?.phoneNumber?.phone || "",
      secondaryDialCode:
        userData?.partner?.phoneNumber?.countryDialCode || "+971",
      secondaryGender: userData?.partner?.gender || "",
      secondaryAddress: userData?.partner?.address || "",
      secondaryReferalCode: userData?.partner?.referedCode || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Full name is required"),

      email: Yup.string()
        .required("Email is required")
        .matches(emailRegex, "Enter a valid email address"),

      address: Yup.string().required("Address is required"),
      gender: Yup.string().required("Gender is required"),

      secondaryName: Yup.string().when([], {
        is: () =>
          selectedValue === UserMembershipType.DUO &&
          alignment === Alignment.ACTIVATE &&
          (id !== userData?.id ||
            userData?.membershipType === UserMembershipType.SINGLE ||
            type === "ADD"),
        then: (schema) => schema.required("Full name is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      secondaryGender: Yup.string().when([], {
        is: () =>
          selectedValue === UserMembershipType.DUO &&
          alignment === Alignment.ACTIVATE &&
          (id !== userData?.id ||
            userData?.membershipType === UserMembershipType.SINGLE ||
            type === "ADD"),
        then: (schema) => schema.required("Gender is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      secondaryAddress: Yup.string().when([], {
        is: () =>
          selectedValue === UserMembershipType.DUO &&
          alignment === Alignment.ACTIVATE &&
          (id !== userData?.id ||
            userData?.membershipType === UserMembershipType.SINGLE ||
            type === "ADD"),
        then: (schema) => schema.required("Address is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      secondaryEmail: Yup.string().when([], {
        is: () =>
          selectedValue === UserMembershipType.DUO &&
          alignment === Alignment.ACTIVATE &&
          (id !== userData?.id ||
            userData?.membershipType === UserMembershipType.SINGLE ||
            type === "ADD"),
        then: (schema) =>
          schema
            .required("Email is required")
            .matches(emailRegex, "Enter a valid email address"),
        otherwise: (schema) => schema.notRequired(),
      }),

      partnerEmail: Yup.string().when([], {
        is: () =>
          selectedValue === UserMembershipType.DUO &&
          alignment === Alignment.INVITE &&
          (id !== userData?.id ||
            userData?.membershipType === UserMembershipType.SINGLE ||
            type === "ADD"),
        then: (schema) =>
          schema
            .required("Email is required")
            .matches(emailRegex, "Enter a valid email address"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);

      if (!dob) {
        return;
      }

      if (!selectedInterests?.length) {
        showError("Please select Interests");
        return;
      }

      if (!selectedExpertise?.length) {
        showError("Please select Expertise");
        return;
      }

      if (!selectedDietary?.length) {
        showError("Please select Dietary");
        return;
      }

      if (
        selectedValue === UserMembershipType.DUO &&
        userData?.membershipType === UserMembershipType.SINGLE &&
        !secondaryDob
      ) {
        return;
      }

      if (
        (selectedValue === UserMembershipType.DUO &&
          alignment === Alignment.ACTIVATE &&
          id !== userData?.id &&
          !selectedPartnerInterests?.length) ||
        (selectedValue === UserMembershipType.DUO &&
          alignment === Alignment.ACTIVATE &&
          !selectedPartnerInterests?.length &&
          userData?.membershipType === UserMembershipType.SINGLE)
      ) {
        showError("Please select  Interests");
        return;
      }

      if (
        (selectedValue === "Duo" &&
          alignment === "activate" &&
          id !== userData?.id &&
          !selectedPartnerExpertise?.length) ||
        (selectedValue === "Duo" &&
          alignment === "activate" &&
          !selectedPartnerExpertise?.length &&
          userData?.membershipType === "Single")
      ) {
        showError("Please select Expertise");
        return;
      }
      if (
        (selectedValue === "Duo" &&
          alignment === "activate" &&
          id !== userData?.id &&
          !selectedPartnerDietary?.length) ||
        (selectedValue === "Duo" &&
          alignment === "activate" &&
          !selectedPartnerDietary?.length &&
          userData?.membershipType === "Single")
      ) {
        showError("Please select Dietary");
        return;
      }

      if (
        (selectedValue1 !== "Paid" &&
          !endDate &&
          !id &&
          alignment === "activate") ||
        (userData?.membershipType === "Single" &&
          selectedValue === "Duo" &&
          !endDate &&
          alignment === "activate" &&
          selectedValue1 !== "Paid")
      ) {
        showError("Please enter expiry date");
        return;
      }

      if (selectedValue1 === "Paid" && !selectedPayer) {
        showError("Please select Payer");
        return;
      }

      const body = {
        membershipType: selectedValue,
        ...(alignment === Alignment.ACTIVATE
          ? { memberShip: selectedValue1 }
          : {}),
        ...(selectedValue1 === MembershipStatus.PAID
          ? { payer: selectedPayer }
          : {}),
        ...(selectedValue === MembershipType.DUO
          ? { isPartnerAdded: alignment === Alignment.ACTIVATE }
          : {}),
        ...(selectedValue === MembershipType.DUO &&
        alignment !== Alignment.ACTIVATE
          ? { partnerEmail: values.partnerEmail }
          : {}),
        ...(selectedValue === MembershipType.DUO
          ? { isPartnerInvited: values.isInvited }
          : {}),
        ...(selectedValue1 !== MembershipStatus.PAID &&
        alignment === Alignment.ACTIVATE
          ? { membershipEndDate: endDate ? dayjs(endDate).toISOString() : "" }
          : {}),

        ...(id ? { userId: id } : {}),
        primaryUser: {
          name: values.name,
          email: values.email,
          phoneNumber: values.phoneNumber,
          countryDialCode: values.countryDialCode,
          gender: values.gender,
          dateOfBirth: dob?.toISOString() || "",
          address: values.address,
          referalCode: values.referalCode,
          interests: selectedInterests,
          expertiseFields: selectedExpertise,
          dietaryUsers: selectedDietary,
        },
        ...(selectedValue === MembershipType.DUO &&
        alignment === Alignment.ACTIVATE
          ? {
              secondaryUser: {
                name: values.secondaryName,
                email: values.secondaryEmail,
                phoneNumber: values.secondaryPhoneNumber,
                countryDialCode: values.secondaryDialCode,
                gender: values.secondaryGender,
                dateOfBirth: secondaryDob?.toISOString() || "",
                address: values.secondaryAddress,
                referalCode: values.secondaryReferalCode,
                interests: selectedPartnerInterests,
                expertiseFields: selectedPartnerExpertise,
                dietaryUsers: selectedPartnerDietary,
              },
            }
          : {}),
      };

      const editBody = {
        membershipType: selectedValue,
        userId: id,
        name: id === userData?.id ? values.name : values.secondaryName,
        email: id === userData?.id ? values.email : values.secondaryEmail,
        phoneNumber:
          id === userData?.id
            ? values.phoneNumber
            : values.secondaryPhoneNumber,
        countryDialCode:
          id === userData?.id
            ? values.countryDialCode
            : values.secondaryDialCode,
        gender: id === userData?.id ? values.gender : values.secondaryGender,
        dateOfBirth:
          id === userData?.id
            ? dob?.toISOString()
            : secondaryDob?.toISOString(),
        address: id === userData?.id ? values.address : values.secondaryAddress,
        referalCode:
          id === userData?.id
            ? values.referalCode
            : values.secondaryReferalCode,
        interests:
          id === userData?.id ? selectedInterests : selectedPartnerInterests,
        expertiseFields:
          id === userData?.id ? selectedExpertise : selectedPartnerExpertise,
        dietaryUsers:
          id === userData?.id ? selectedDietary : selectedPartnerDietary,
      };

      const soloToDuoBody = {
        membershipType: selectedValue,
        ...(alignment === Alignment.ACTIVATE
          ? { memberShip: selectedValue1 }
          : {}),
        ...(selectedValue1 === MembershipStatus.PAID
          ? { payer: selectedPayer }
          : {}),
        ...(selectedValue === MembershipType.DUO
          ? { isPartnerAdded: alignment === Alignment.ACTIVATE }
          : {}),
        ...(selectedValue === MembershipType.DUO &&
        alignment !== Alignment.ACTIVATE
          ? { partnerEmail: values.partnerEmail }
          : {}),
        ...(selectedValue === MembershipType.DUO
          ? { isPartnerInvited: values.isInvited }
          : {}),
        ...(selectedValue1 !== MembershipStatus.PAID &&
        alignment === Alignment.ACTIVATE
          ? { membershipEndDate: endDate ? dayjs(endDate).toISOString() : "" }
          : {}),

        ...(id ? { userId: id } : {}),

        name: values.name,
        email: values.email,
        phoneNumber: values.phoneNumber,
        countryDialCode: values.countryDialCode,
        gender: values.gender,
        dateOfBirth: dob?.toISOString() || "",
        address: values.address,
        referalCode: values.referalCode,
        interests: selectedInterests,
        expertiseFields: selectedExpertise,
        dietaryUsers: selectedDietary,

        ...(selectedValue === MembershipType.DUO &&
        alignment === Alignment.ACTIVATE
          ? {
              secondaryUser: {
                name: values.secondaryName,
                email: values.secondaryEmail,
                phoneNumber: values.secondaryPhoneNumber,
                countryDialCode: values.secondaryDialCode,
                gender: values.secondaryGender,
                dateOfBirth: secondaryDob?.toISOString() || "",
                address: values.secondaryAddress,
                referalCode: values.secondaryReferalCode,
                interests: selectedPartnerInterests,
                expertiseFields: selectedPartnerExpertise,
                dietaryUsers: selectedPartnerDietary,
              },
            }
          : {}),
      };

      if (id) {
        try {
          setLoading(true);
          const response = await updateUser(
            selectedValue === UserMembershipType?.DUO &&
              userData?.membershipType === UserMembershipType?.SINGLE
              ? soloToDuoBody
              : editBody
          ).unwrap();
          setLoading(false);
          if (response?.status === 200) {
            formik.resetForm();
            showToast(response?.message || "");
            navigate("/manage-customers");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "Something went wrong");
        }
      } else {
        try {
          setLoading(true);
          const response = await addUser(body).unwrap();
          setLoading(false);
          if (response?.status === 200) {
            showToast(response?.message || "");
            formik.resetForm();
            navigate("/manage-customers");
          } else {
            setLoading(false);
            showError(response?.message || "");
          }
        } catch (error: any) {
          showError(error?.data?.message || "Something went wrong");
        }
      }

      formik.setSubmitting(false);
    },
  });

  const getInterestApi: any = async () => {
    setLoading(true);
    try {
      const response = await getInterest({
        page: 1,
        search: "",
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setInterests(response?.data || []);
        // setCount(response?.data?.totalCount || 0);
      } else {
        setLoading(false);
        setInterests([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getExpertiseApi: any = async () => {
    setLoading(true);
    try {
      const response = await getExpertise({
        page: 1,
        search: "",
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setExpertise(response?.data?.items || []);
      } else {
        setLoading(false);
        setInterests([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getDietaryApi: any = async () => {
    setLoading(true);
    try {
      const response = await getDietary({
        page: 1,
        search: "",
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setDietary(response?.data || []);
      } else {
        setLoading(false);
        setInterests([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const userDetailsApi = async () => {
    setLoading(true);

    try {
      const response = await userDetails({ userId: id }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setUserData(response?.data);
        setSelectedValue(response?.data?.membershipType || "Single");
        setDob(
          response?.data?.dateOfBirth
            ? dayjs(response?.data?.dateOfBirth)
            : null
        );
        setSelectedExpertise(response?.data?.expertiseField || []);
        setSelectedDietary(response?.data?.dietary || []);
        setSelectedInterests(response?.data?.interests || []);
        setSelectedPartnerDietary(response?.data?.partner?.dietary || []);
        setSelectedPartnerExpertise(
          response?.data?.partner?.expertiseField || []
        );
        setSelectedPartnerInterests(response?.data?.partner?.interests || []);
        setSecondaryDob(
          response?.data?.partner?.dateOfBirth
            ? dayjs(response?.data?.partner?.dateOfBirth)
            : null
        );
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getInterestApi();
    getExpertiseApi();
    getDietaryApi();
    if (id) {
      userDetailsApi();
    }
  }, []);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            {id ? "Edit Customer" : "User Management"}
          </h1>
        </div>
        <div className="cards">
          <form onSubmit={formik.handleSubmit}>
            <div className="gap_m avnc_bkng">
              {userData?.userStatus === "Pending" || type === "ADD" ? (
                <div className="control_group w_100">
                  <FormLabel className="form_label">Type</FormLabel>

                  <FormControl className="paid_radio">
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="Single"
                        control={<Radio />}
                        label="Single"
                        // disabled={
                        //   id && userData?.membershipType === "Single"
                        //     ? true
                        //     : false
                        // }
                        sx={{
                          "&.Mui-disabled": {
                            color: "#ffffff",
                          },
                          "&.Mui-disabled .MuiFormControlLabel-label": {
                            color: "#ffffff",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="Duo"
                        control={<Radio />}
                        label="Duo"
                        // disabled={
                        //   id && userData?.membershipType === "Single"
                        //     ? true
                        //     : false
                        // }
                        sx={{
                          "&.Mui-disabled": {
                            color: "#ffffff", // fallback
                          },
                          "&.Mui-disabled .MuiFormControlLabel-label": {
                            color: "#ffffff", // THIS targets the label text correctly
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              ) : null}

              {id === userData?.id ? (
                <>
                  {" "}
                  <div className="control_group w_33">
                    <label htmlFor="name">Full Name*</label>
                    <TextField
                      placeholder="Enter Full Name"
                      hiddenLabel
                      fullWidth
                      inputProps={{ maxLength: 40 }}
                      name="name"
                      id="name"
                      className="text_field"
                      value={formik.values.name}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.name &&
                        typeof formik.errors.name === "string"
                          ? formik.errors.name
                          : ""
                      }
                    />
                  </div>
                  <div className="control_group w_33">
                    <label>Phone Number*</label>
                    <PhoneInput
                      enableSearch
                      value={
                        formik.values.countryDialCode +
                        formik.values.phoneNumber
                      }
                      country={"uae"}
                      inputClass="phoneInput"
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      inputStyle={{ width: "100%", backgroundColor: "#232323" }}
                      buttonClass="phoneBtn"
                      placeholder="Phone Number"
                    />
                    <p className="err_msg">
                      {submitted && !formik.values.phoneNumber?.length
                        ? "Phone number is required"
                        : ""}
                    </p>
                  </div>
                  <div className="control_group w_33">
                    <label htmlFor="address">Address</label>
                    <TextField
                      placeholder="Enter Address*"
                      hiddenLabel
                      fullWidth
                      inputProps={{ maxLength: 80 }}
                      name="address"
                      id="address"
                      className="text_field"
                      value={formik.values.address}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.address &&
                        typeof formik.errors.address === "string"
                          ? formik.errors.address
                          : ""
                      }
                    />
                  </div>
                  <div className="control_group w_33">
                    <label htmlFor="email">Email*</label>
                    <TextField
                      placeholder="Enter Email"
                      hiddenLabel
                      fullWidth
                      name="email"
                      id="email"
                      className="text_field"
                      value={formik.values.email}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.email &&
                        typeof formik.errors.email === "string"
                          ? formik.errors.email
                          : ""
                      }
                    />
                  </div>
                  <div className="w_33 control_group date_field">
                    <label>Birthday</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={dob}
                        onChange={(newValue) => setDob(newValue)}
                        className="form_control"
                        format="DD/MM/YYYY"
                        maxDate={dayjs().subtract(3, "year")}
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          // textField: (params) => (
                          //   <TextField
                          //     {...params}
                          //     fullWidth
                          //     placeholder="Date"
                          //     hiddenLabel
                          //   />
                          // ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                    <p className="err_msg">
                      {submitted && !dob ? "Birthday is required" : ""}
                    </p>
                  </div>
                  <div className="form_group w_33">
                    <label>Gender</label>
                    <Select
                      value={formik.values.gender}
                      name="page"
                      onChange={handleChangeGender}
                      displayEmpty
                    >
                      <MenuItem value={""} disabled>
                        Select Gender
                      </MenuItem>
                      <MenuItem value={"Male"}>Male</MenuItem>
                      <MenuItem value={"Female"}>Female</MenuItem>
                      <MenuItem value={"Other"}>Other</MenuItem>
                    </Select>
                    <p className="err_msg">
                      {submitted && !formik.values.gender?.length
                        ? "Gender is required"
                        : ""}
                    </p>
                  </div>
                  <div className="control_group w_33">
                    <label htmlFor="referalCode">
                      Referral Code (Optional)
                    </label>
                    <TextField
                      placeholder="Enter Referral Code"
                      hiddenLabel
                      fullWidth
                      inputProps={{ maxLength: 40 }}
                      name="referalCode"
                      id="referalCode"
                      className="text_field"
                      value={formik.values.referalCode}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.referalCode &&
                        typeof formik.errors.referalCode === "string"
                          ? formik.errors.referalCode
                          : ""
                      }
                    />
                  </div>
                  <div className="control_group w_100">
                    <FormLabel className="form_label">Interests*</FormLabel>
                    <FormGroup className="text_checkbox">
                      {interests?.map((interest, index) => (
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              checked={selectedInterests?.includes(
                                interest?.name
                              )}
                              onChange={() =>
                                handleInterestChange(interest?.name)
                              }
                            />
                          }
                          label={interest?.name}
                        />
                      ))}
                    </FormGroup>
                  </div>
                  <div className="control_group w_100">
                    <FormLabel className="form_label">
                      Field of expertise*
                    </FormLabel>
                    <FormGroup className="text_checkbox">
                      {expertise?.map((expertise: any, index) => (
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              checked={selectedExpertise?.includes(
                                expertise?.name
                              )}
                              onChange={() =>
                                handleChangeExpertise(expertise?.name)
                              }
                            />
                          }
                          label={expertise?.name}
                        />
                      ))}
                    </FormGroup>
                  </div>
                  <div className="control_group w_100">
                    <FormLabel className="form_label">
                      Dietary Requirements*
                    </FormLabel>
                    <FormGroup className="text_checkbox">
                      {dietary?.map((item: any, index) => (
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              checked={selectedDietary?.includes(item)}
                              onChange={() => handleChangeDietary(item)}
                            />
                          }
                          label={item}
                        />
                      ))}
                    </FormGroup>
                  </div>
                </>
              ) : null}

              {selectedValue === "Duo" ? (
                <>
                  <div className="control_group w_100">
                    <hr className="m_5" />
                  </div>
                  {id ? (
                    <div className="control_group w_100">
                      <h2>Secondary/Parnter Detail</h2>
                    </div>
                  ) : (
                    <div className="control_group w_100">
                      <h2>Add Secondary/Parnter Detail</h2>
                    </div>
                  )}

                  {id && userData?.membershipType === "Duo" ? null : (
                    <div className="control_group w_100 ">
                      <FormLabel className="form_label">
                        Do you want fill detail?
                      </FormLabel>
                      <div className="archv_ryt">
                        <ToggleButtonGroup
                          color="primary"
                          value={alignment}
                          exclusive
                          onChange={handleChangeToggle}
                          aria-label="Platform"
                        >
                          <ToggleButton value="activate">Yes </ToggleButton>
                          <ToggleButton value="archived">No</ToggleButton>
                        </ToggleButtonGroup>
                      </div>
                    </div>
                  )}

                  {alignment === "activate" ? (
                    <>
                      <div className="control_group w_33">
                        <label htmlFor="secondaryName">Full Name*</label>
                        <TextField
                          placeholder="Enter Full Name"
                          hiddenLabel
                          fullWidth
                          disabled={userData?.membershipType === "Duo"}
                          name="secondaryName"
                          id="secondaryName"
                          className="text_field"
                          value={formik.values.secondaryName}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          helperText={
                            formik.touched.secondaryName &&
                            typeof formik.errors.secondaryName === "string"
                              ? formik.errors.secondaryName
                              : ""
                          }
                        />
                      </div>
                      <div className="control_group w_33">
                        <label>Phone Number*</label>
                        <PhoneInput
                          enableSearch
                          disabled={userData?.membershipType === "Duo"}
                          value={
                            formik.values.secondaryDialCode +
                            formik.values.secondaryPhoneNumber
                          }
                          country={"uae"}
                          inputClass="phoneInput"
                          onChange={(phone, country) =>
                            handleChangeSecondaryPhone(phone, country)
                          }
                          inputStyle={{
                            width: "100%",
                            backgroundColor: "#232323",
                          }}
                          buttonClass="phoneBtn"
                          placeholder="Phone Number"
                        />
                        <p className="err_msg">
                          {submitted &&
                          !formik.values.secondaryPhoneNumber?.length
                            ? "Phone number is required"
                            : ""}
                        </p>
                      </div>

                      <div className="control_group w_33">
                        <label htmlFor="secondaryAddress">Address</label>
                        <TextField
                          placeholder="Enter Address*"
                          hiddenLabel
                          fullWidth
                          name="secondaryAddress"
                          id="secondaryAddress"
                          className="text_field"
                          disabled={userData?.membershipType === "Duo"}
                          value={formik.values.secondaryAddress}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          helperText={
                            formik.touched.secondaryAddress &&
                            typeof formik.errors.secondaryAddress === "string"
                              ? formik.errors.secondaryAddress
                              : ""
                          }
                        />
                      </div>
                      <div className="control_group w_33">
                        <label htmlFor="secondaryEmail">Email*</label>
                        <TextField
                          placeholder="Enter Email"
                          hiddenLabel
                          fullWidth
                          name="secondaryEmail"
                          id="secondaryEmail"
                          className="text_field"
                          disabled={userData?.membershipType === "Duo"}
                          value={formik.values.secondaryEmail}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          helperText={
                            formik.touched.secondaryEmail &&
                            typeof formik.errors.secondaryEmail === "string"
                              ? formik.errors.secondaryEmail
                              : ""
                          }
                        />
                      </div>

                      <div className="w_33 control_group date_field">
                        <label>Birthday</label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="form_control"
                            value={secondaryDob}
                            disabled={userData?.membershipType === "Duo"}
                            onChange={(newValue) => setSecondaryDob(newValue)}
                            format="DD/MM/YYYY"
                            maxDate={dayjs().subtract(3, "year")}
                            slots={{
                              openPickerIcon: () => (
                                <img
                                  src="/static/images/calendar_icon.svg"
                                  alt="icon"
                                />
                              ),
                              // textField: (params) => (
                              //   <TextField
                              //     {...params}
                              //     fullWidth
                              //     placeholder="Date"
                              //     hiddenLabel
                              //   />
                              // ),
                            }}
                            desktopModeMediaQuery="(min-width:0px)"
                          />
                          <p className="err_msg">
                            {submitted && !secondaryDob
                              ? "Birthday is required"
                              : ""}
                          </p>
                        </LocalizationProvider>
                      </div>
                      <div className="form_group w_33">
                        <label>Gender</label>
                        <Select
                          value={formik.values.secondaryGender}
                          name="page"
                          disabled={userData?.membershipType === "Duo"}
                          onChange={handleChangeSecondaryGender}
                          displayEmpty
                          sx={{
                            "& .MuiSelect-select.Mui-disabled": {
                              color: "rgba(255,255,255,0.3)",
                              WebkitTextFillColor: "rgba(255,255,255,0.3)",
                            },
                          }}
                        >
                          <MenuItem value={""} disabled>
                            Select Gender
                          </MenuItem>
                          <MenuItem value={"Male"}>Male</MenuItem>
                          <MenuItem value={"Female"}>Female</MenuItem>
                          <MenuItem value={"Other"}>Other</MenuItem>
                        </Select>
                        <p className="err_msg">
                          {submitted && !formik.values.secondaryGender?.length
                            ? "Gender is required"
                            : ""}
                        </p>
                      </div>

                      <div className="control_group w_33">
                        <label htmlFor="secondaryReferalCode">
                          Referral Code (Optional)
                        </label>
                        <TextField
                          placeholder="Enter Referral Code"
                          hiddenLabel
                          fullWidth
                          name="secondaryReferalCode"
                          disabled={userData?.membershipType === "Duo"}
                          id="secondaryReferalCode"
                          className="text_field"
                          value={formik.values.secondaryReferalCode}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          helperText={
                            formik.touched.secondaryReferalCode &&
                            typeof formik.errors.secondaryReferalCode ===
                              "string"
                              ? formik.errors.secondaryReferalCode
                              : ""
                          }
                        />
                      </div>
                      <div className="control_group w_100">
                        <FormLabel component="legend" className="form_label">
                          Interests*
                        </FormLabel>
                        <FormGroup className="text_checkbox">
                          {interests?.map((interest, index) => (
                            <FormControlLabel
                              disabled={userData?.membershipType === "Duo"}
                              key={index}
                              sx={{
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: "rgba(255,255,255,0.3)",
                                  opacity: 1,
                                },
                              }}
                              control={
                                <Checkbox
                                  checked={selectedPartnerInterests?.includes(
                                    interest?.name
                                  )}
                                  onChange={() =>
                                    handlePartnerInterestChange(interest?.name)
                                  }
                                />
                              }
                              label={interest?.name}
                            />
                          ))}
                        </FormGroup>
                      </div>

                      <div className="control_group w_100">
                        <FormLabel component="legend" className="form_label">
                          Field of expertise*
                        </FormLabel>
                        <FormGroup className="text_checkbox">
                          {expertise?.map((expertise: any, index) => (
                            <FormControlLabel
                              disabled={userData?.membershipType === "Duo"}
                              key={index}
                              sx={{
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: "rgba(255,255,255,0.3)",
                                  opacity: 1,
                                },
                              }}
                              control={
                                <Checkbox
                                  checked={selectedPartnerExpertise?.includes(
                                    expertise?.name
                                  )}
                                  onChange={() =>
                                    handleChangePartnerExpertise(
                                      expertise?.name
                                    )
                                  }
                                />
                              }
                              label={expertise?.name}
                            />
                          ))}
                        </FormGroup>
                      </div>

                      <div className="control_group w_100">
                        <FormLabel component="legend" className="form_label">
                          Dietary Requirements*
                        </FormLabel>
                        <FormGroup className="text_checkbox">
                          {dietary?.map((item: any, index) => (
                            <FormControlLabel
                              disabled={userData?.membershipType === "Duo"}
                              key={index}
                              sx={{
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: "rgba(255,255,255,0.3)",
                                  opacity: 1,
                                },
                              }}
                              control={
                                <Checkbox
                                  checked={selectedPartnerDietary?.includes(
                                    item
                                  )}
                                  onChange={() =>
                                    handleChangePartnerDietary(item)
                                  }
                                />
                              }
                              label={item}
                            />
                          ))}
                        </FormGroup>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="control_group w_33">
                        <label htmlFor="partnerEmail">
                          {" "}
                          Secondary/Parnter Email
                        </label>
                        <TextField
                          placeholder="Enter Email"
                          hiddenLabel
                          name="partnerEmail"
                          id="partnerEmail"
                          className="text_field"
                          fullWidth
                          value={formik.values.partnerEmail}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          helperText={
                            formik.touched.partnerEmail &&
                            typeof formik.errors.partnerEmail === "string"
                              ? formik.errors.partnerEmail
                              : ""
                          }
                        />
                      </div>
                      <div className="control_group w_100">
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Send Inventation"
                            checked={formik.values.isInvited}
                            name="isInvited"
                            disabled
                            sx={{
                              "&.Mui-disabled": {
                                color: "#ffffff", // fallback
                              },
                              "&.Mui-disabled .MuiFormControlLabel-label": {
                                color: "#ffffff", // THIS targets the label text correctly
                              },
                            }}
                            onChange={formik.handleChange}
                          />
                        </FormGroup>
                      </div>
                    </>
                  )}
                </>
              ) : null}
              {(id ||
                alignment === "archived" ||
                userData?.membershipType === "Duo") &&
              !(
                id &&
                userData?.membershipType === "Single" &&
                selectedValue === "Duo"
              ) ? null : (
                <>
                  {" "}
                  <div className="control_group w_100">
                    {/* <label>Type</label> */}

                    <FormControl className="paid_radio select_payer">
                      <FormLabel
                        style={{ color: "#fff" }}
                        id="type-radio-group-label"
                      >
                        Type
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="type-radio-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        value={selectedValue1}
                        onChange={handleChangeNewRadio}
                      >
                        <FormControlLabel
                          value="Trial"
                          control={<Radio />}
                          label="Free Trial"
                        />
                        <FormControlLabel
                          value="Complimentary"
                          control={<Radio />}
                          label="Complementary"
                        />

                        <FormControlLabel
                          value="Paid"
                          control={<Radio />}
                          label="Paid"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {selectedValue1 === "Paid" ? (
                    <div className="form_group w_33">
                      <label htmlFor="select_payer">Select Payer</label>
                      <Select
                        id="select_payer"
                        value={selectedPayer}
                        name="page"
                        onChange={handleChangePayer}
                        displayEmpty
                      >
                        <MenuItem value={""} disabled>
                          Select Payer
                        </MenuItem>
                        <MenuItem value={"Primary"}>Primary Member</MenuItem>
                        <MenuItem value={"Secondary"}>
                          Secondary Member
                        </MenuItem>
                        <MenuItem value={"Split"}>Split</MenuItem>
                      </Select>
                    </div>
                  ) : (
                    <div className="w_33 control_group date_field">
                      <label>Expiry Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          minDate={dayjs()}
                          className="form_control"
                          value={endDate}
                          format="DD/MM/YYYY"
                          onChange={(newValue) => setEndDate(newValue)}
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                            // textField: (params) => (
                            //   <TextField
                            //     {...params}
                            //     fullWidth
                            //     placeholder="Date"
                            //     hiddenLabel
                            //   />
                            // ),
                          }}
                          desktopModeMediaQuery="(min-width:0px)"
                        />
                      </LocalizationProvider>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="btn_flex mt_30">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setSubmitted(true);
                }}
                type="submit"
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </MainContainer>
    </>
  );
}

export default AddUser;
